import React, { useEffect } from 'react'
import useApi from '../../../../hooks/useApi';
import { useParams } from "react-router-dom";
import { LoadingComponent } from 'usbc-web-react-library';
import CardContainer from '../../../Shared/Card/CardContainer';
import { currencyFormat, updateStepData } from '../../../Shared/helpers';
import AnimatedExclamation from '../../../Shared/Animation/AnimatedExclamation';
import { user_add_icon, youth_usbc_icon } from '../../../Shared/icons';
import MembershipProductOptions from '../../../Shared/MembershipSelection/MembershipProductOptions';


function MembershipCostAck(props) {
    let { lid, season } = useParams();

    const {
        fetchData: getMembershipProduct,
        response: productInfo,
        loading: productInfoLoading
    } = useApi();

    useEffect(() => {

        getMembershipProduct({
            url: 'getmembershipproduct', method: 'POST', body:
            {
                LeagueId: lid,
                MemberId: props.wizardState?.memberId,
                Season: Number(season),
                BowlerInfo: props.wizardState?.bowlerProfile
            }
        });

    }, []);

    const hasYouthProduct = productInfo?.products?.some(p => p.isYouthProduct);

    function onProductClick(product) {
        if (productInfo?.violationMessage) {
            return;
        }

        let stepData = props.wizardState;

        stepData = updateStepData(stepData, {
            isPaymentRequired: productInfo.isPaymentRequired,
            productId: product.id,
            requiresGuardianEmail: productInfo?.memberInfo?.guardianInfo?.requiresGuardianEmail
        });

        props.updateWizardState(stepData);
        props.nextView(stepData);
    }

    function onAlreadyMemberClick() {
        if (productInfo?.violationMessage) {
            return;
        }

        let stepData = props.wizardState;

        stepData = updateStepData(stepData, {
            isPaymentRequired: productInfo.isPaymentRequired,
            requiresGuardianEmail: productInfo?.memberInfo?.guardianInfo?.requiresGuardianEmail
        });

        props.updateWizardState(stepData);
        props.nextView(stepData);
    }

    return (
        <>
            <div className="row">
                <div className="col h4 wizard-step-title">
                    {props.step.title}
                </div>
            </div>
            <div className="row">
                <LoadingComponent isLoading={() => productInfoLoading === true}>
                    <div className="row g-2 d-flex justify-content-center text-center">
                        {!!productInfo?.products?.length ? 
                            <>
                            <div><strong>A Membership is required to join this league:</strong></div>
                            <div className="row g-2 justify-content-center">
                                <div className="col-12 col-md-6">
                                    <MembershipProductOptions
                                        products={productInfo?.products}
                                        onProductClick={onProductClick}
                                    /> 
                                </div>
                            </div></>: (
                            <div className="row g-2 justify-content-center">
                                <div className="col-md-6 card-radio" onClick={() => onAlreadyMemberClick()}>
                                    <CardContainer icon={user_add_icon}>
                                        <h5 className="card-title">
                                            <strong>{productInfo?.memberInfo?.memberName} already has a membership</strong>
                                        </h5>
                                        <p className="card-text">{productInfo?.productInfo?.name}</p>
                                        <p className="card-text">Click this card to continue</p>
                                    </CardContainer>
                                </div>
                             </div>
                        )}
                        <div className={productInfo?.violationMessage ? "col-md-6" : "col-md-6 card-radio"} disabled={productInfo?.violationMessage}>
                            {(productInfo?.violationMessage) &&
                                <CardContainer icon={AnimatedExclamation()}>
                                    <h5 className="card-title"><strong>{productInfo?.violationMessage} </strong></h5>
                                    <p className="card-text">{productInfo?.productInfo?.name}</p>
                                </CardContainer>
                            }
                        </div>
                    </div>
                </LoadingComponent>
            </div>
            <div className='wizard-buttons-container'>
                <button type="button" className="btn btn-primary bowl-btn" onClick={props.backView}>Back</button>
            </div>
        </>
    )
}

export default MembershipCostAck